import apiUrls from '../constants/urls'
import axios from 'axios'

export default {
  getAirport (research) {
    const url = apiUrls.backEnd.airport + research
    return axios.get(url)
  },
  getCountries () {
    const url = apiUrls.countryService.countriesListWithFlag
    return axios.get(url)
  }
}
